import { useEffect, useMemo, useState } from "react";

const DESKTOP = {
    left: "/light-left.riv",
    right: "/light-right.riv",
};

const MOBILE = {
    left: "/m-light-left.riv",
    right: "/m-light-right.riv",
};

function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(() =>
        typeof window === "undefined" ? false : window.innerWidth < breakpoint
    );

    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth < breakpoint);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, [breakpoint]);

    return isMobile;
}

export default function RiveWrapper({ className = "" }) {
    const [RiveComponent, setRiveComponent] = useState(null);
    const isMobile = useIsMobile(768);

    useEffect(() => {
        import("@rive-app/react-canvas").then((mod) => {
            setRiveComponent(() => mod.default);
        });
    }, []);

    const srcs = useMemo(() => (isMobile ? MOBILE : DESKTOP), [isMobile]);

    if (!RiveComponent) return null;

    return (
        <div className={`absolute inset-0 pointer-events-none ${className}`}>
            {/* Left half */}
            <div className="absolute inset-y-0 left-0 w-1/2 overflow-hidden">
                <RiveComponent src={srcs.left} autoplay className="w-full h-full object-cover" />
            </div>

            {/* Right half */}
            <div className="absolute inset-y-0 right-0 w-1/2 overflow-hidden">
                <RiveComponent src={srcs.right} autoplay className="w-full h-full object-cover" />
            </div>
        </div>
    );
}
